<script>
import { HorizontalBar, mixins } from 'vue-chartjs';

const { reactiveProp } = mixins;

export default {
  extends: HorizontalBar,
  props: ['chartData'],
  mixins: [reactiveProp],
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      tooltips: { enabled: false },
      scales: {
        xAxes: [{ gridLines: { display: false }, ticks: { display: false } }],
        yAxes: [{ gridLines: { display: false } }],
      },
    },
  }),
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
